handlePutUserProfileImages